import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { FaRegClock } from 'react-icons/fa';
import { FaAngleRight } from 'react-icons/fa';
import { LuHeart } from 'react-icons/lu';
import { FaRegFileAlt } from 'react-icons/fa';
import { RxPencil2 } from 'react-icons/rx';
import { FaHeart } from 'react-icons/fa';
import { FiEdit2 } from 'react-icons/fi';
import { FiTrash2 } from 'react-icons/fi';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { getMyBookMemos, getMyBookByBookId, getTotalRecord, addMyBookMemo, modifyMyBookMemo, deleteMyBookMemo, putMyBookScore, putMyBookReadPage } from '../api/BookcaseApi';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { getDday, formatTime, stringFrDate } from '../common/utils';
import { ownership2text, RecordType } from '../common/enums';
import LoadingOverlay from '../components/LoadingOverlay';
import { ErrorContainer, ErrorMessage } from '../components/ErrorContainer';
import { useNoobookContext } from '../context/NoobookContext';
import BookHistoryPage from './BookHistoryPage';
import { FaTimes } from 'react-icons/fa';



const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
`;
const BookInfoBox = styled.div`
  background: #eae8e9;
  padding: 32px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const BookInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0 8px 0;
`;
const Dday = styled.div`
  background: #636363;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;
const Title = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: #222;
  margin-top: 8px;
  margin-bottom: 2px;
  padding: 0 16px 0 16px;
`;
const Author = styled.div`
  font-size: 15px;
  color: #888;
  margin-bottom: 4px;
`;
const Period = styled.div`
  font-size: 13px;
  color: #888;
  margin-bottom: 10px;
`;
const Badge = styled.span`
  background: #1976d2;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;
const InfoRow = styled.div`
  display: flex;
  gap: 18px;
  justify-content: center;
  margin-bottom: 18px;
`;
const InfoCard = styled.div`
  background: #fff;
  border: 2px solid #dedede;
  border-radius: 14px;
  width: 110px;
  height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #888;
  font-weight: 500;
  cursor: pointer;
`;
const InfoValue = styled.div`
  color: #2346a9;
  font-size: 15px;
  font-weight: 700;
  margin-top: 4px;
`;
const MemoSectionBg = styled.div`
  background: #eae8e9;
  padding-bottom: 0;
`;
const MemoSection = styled.div`
  background: #fff;
  border-radius: 16px;
  margin: 0 16px 0 16px;
  padding: 20px 18px 32px 18px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
const MemoHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
`;
const AddMemoBtn = styled.button`
  background: #bdbdbd;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  margin-left: 12px;
  padding: 4px 14px;
  cursor: pointer;
`;
const MemoBox = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 18px 14px;
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 18px;
  position: relative;
`;
const MemoActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 12px;
  padding-top: 8px;
`;
const ActionIcon = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 14px;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #555;
  }
`;
const Pagination = styled.div`
  text-align: center;
  color: #888;
  font-size: 15px;
  margin-top: 8px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const PaginationText = styled.span`
  color: #888;
  font-size: 13px;
  white-space: nowrap;
`;
const MemoBoxContainer = styled.div`
  position: relative;
`;
const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  ${props => props.direction === 'left' && `
    left: -18px;
  `}
  
  ${props => props.direction === 'right' && `
    right: -18px;
  `}
`;
const SeparatorBar = styled.div`
  width: 100%;
  max-width: 440px;
  height: 12px;
  background: #eae8e9;
  border-radius: 4px;
  border-top: 1px solid #fff;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
  margin: 18px auto 32px auto;
`;
const TotalTimeBox = styled.div`
  margin-top: 8px;
  background: #244ac2;
  border-radius: 16px;
  padding: 6px 18px 6px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const TimerIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: 4px;
`;
const TotalTimeText = styled.span`
  color: #fff;
  font-size: 15px;
  font-weight: 500;
`;
const HistoryText = styled.div`
  color: #2346a9;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  margin-top: 6px;
`;
const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;
const ScoreModal = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px 20px 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ScoreRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
`;
const ScoreHeart = styled.span`
  cursor: pointer;
  font-size: 32px;
  color: ${props => props.selected ? '#244ac2' : '#bdbdbd'};
  transition: color 0.15s;
`;
const ModalCloseBtn = styled.button`
  background: #eee;
  color: #555;
  border: none;
  border-radius: 8px;
  padding: 6px 18px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
`;
const MemoModalOverlay = styled(ModalOverlay)``;
const MemoModal = styled(ScoreModal)`
  min-width: 320px;
`;
const MemoTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  border: 1px solid #dedede;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 18px;
  resize: vertical;
  &:focus {
    border: 1px solid #dedede;
    outline: none;
  }
`;
const MemoModalBtnRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;
const MemoModalBtn = styled(ModalCloseBtn)`
  min-width: 64px;
`;

const ReadPageModalOverlay = styled(ModalOverlay)``;
const ReadPageModal = styled(ScoreModal)`
  min-width: 240px;
`;
const ReadPageInput = styled.input`
  width: 30%;
  height: 40px;
  border: 1px solid #dedede;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 16px;
  margin-bottom: 18px;
  text-align: center;
  &:focus {
    border: 1px solid #244ac2;
    outline: none;
  }
`;
const ReadPageModalBtnRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;
const ReadPageModalBtn = styled(ModalCloseBtn)`
  min-width: 64px;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
`;


const BookHistoryModal = ({bookId, onClose }) => {
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>독서 이력</ModalTitle>
        <ModalCloseButton onClick={()=>{onClose(false);}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        <BookHistoryPage propBookId={bookId} onClose={onClose} />
      </ModalContent>
    </Modal>
  )
};






const PAGE_SIZE = 30;

export default function BookRecordPage({propBookId = null, onModified = null}) {
  const { showBack, setShowBack } = useNoobookContext();

  const [scoreModalOpen, setScoreModalOpen] = useState(false);
  //const [myScore, setMyScore] = useState(0);
  const [memoModalOpen, setMemoModalOpen] = useState(false);
  const [memoText, setMemoText] = useState("");
  const [readPageModalOpen, setReadPageModalOpen] = useState(false);
  const [readPageText, setReadPageText] = useState("");
  const [currentMemoIndex, setCurrentMemoIndex] = useState(0);
  const [memos, setMemos] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editText, setEditText] = useState("");
  const [editingIndex, setEditingIndex] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deletingIndex, setDeletingIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bookData, setBookData] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalMemos, setTotalMemos] = useState(0);
  const [totalReadTime, setTotalReadTime] = useState(0);
  const [totalReadCnt, setTotalReadCnt] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  
  const { bookId:argBookId } = useParams();
  const [bookId, setBookId] = useState(propBookId ? propBookId : argBookId);
  const [showBookHistoryModal, setShowBookHistoryModal] = useState(false);
  //const totalMemos = memos.length;
  const navigate = useNavigate();

  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(true);
    return () => setShowBack(prevShowBack);
  }, []);

  // 초기 데이터 로드
  useEffect(() => {
    const loadInitialData = async () => {
      if (!bookId) return;
      
      setLoading(true);
      try {
        const { accessToken } = await getAccessToken();
        
        // 책 정보 로드
        const bookResponse = await getMyBookByBookId(accessToken || '', parseInt(bookId));
        const processedBookResponse = processApiResponse(bookResponse);
        
        if (!processedBookResponse.success) {
          setError(processedBookResponse.errorMessage);
          return;
        }
        
        setBookData(processedBookResponse.data);


        // 총 독서 시간 조회
        const totalResponse = await getTotalRecord(accessToken || '', parseInt(bookId), RecordType.READING);
        const processedTotalResponse = processApiResponse(totalResponse);
        
        if (processedTotalResponse.success) {
          setTotalReadTime(processedTotalResponse.data.totalTimeInSec || 0);
          setTotalReadCnt(processedTotalResponse.data.totalCnt || 0);
        } else {
          console.error('총 독서 시간 조회 실패:', processedTotalResponse.errorMessage);
          //setError(processedTotalResponse.errorMessage);
        }


        
        // 첫 페이지 메모 로드
        const memosResponse = await getMyBookMemos(accessToken || '', parseInt(bookId), 0, 10);
        const processedMemosResponse = processApiResponse(memosResponse);
        
        if (processedMemosResponse.success) {
          setMemos(processedMemosResponse.data || []);
          //setHasMore((processedMemosResponse.data || []).length === 10);
          setHasMore(processedMemosResponse.page.current < processedMemosResponse.page.last);
          setCurrentPage(processedMemosResponse.page.current);
          setTotalMemos(processedMemosResponse.page.total);
          
        } else {
          setError(processedMemosResponse.errorMessage);
        }
        
      } catch (error) {
        console.error('데이터 로드 중 오류:', error);
        setError('네트워크 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };
    
    loadInitialData();
  }, [bookId]);

  // 다음 페이지 메모 로드
  const loadMoreMemos = async () => {
    if (!hasMore || loadingMore) return;
    
    setLoadingMore(true);
    try {
      const { accessToken } = await getAccessToken();
      const nextPage = currentPage + 1;
      
      const memosResponse = await getMyBookMemos(accessToken || '', parseInt(bookId), nextPage, 10);
      const processedMemosResponse = processApiResponse(memosResponse);
      
      if (processedMemosResponse.success) {
        const newMemos = processedMemosResponse.data || [];
        //console.log(newMemos[0].memo);
        setMemos(prev => [...prev, ...newMemos]);
        setCurrentPage(processedMemosResponse.page.current);
        setHasMore(processedMemosResponse.page.current < processedMemosResponse.page.last);
        setTotalMemos(processedMemosResponse.page.total);
      } else {
        console.error('메모 로드 실패:', processedMemosResponse.errorMessage);
      }
      
    } catch (error) {
      console.error('메모 로드 중 오류:', error);
    } finally {
      setLoadingMore(false);
    }
  };

  const handleScoreClick = (score) => {
    setBookData(prev => ({ ...prev, score: score }));
    //setMyScore(score);
    setTimeout(async () => {
      if (onModified) {
        onModified();
      }
      setScoreModalOpen(false);
      try {
        setLoading(true);
        const { accessToken } = await getAccessToken();
        // 서버에 점수 저장
        const response = await putMyBookScore(accessToken || '', parseInt(bookId), score);
        const processedResponse = processApiResponse(response);
        if (processedResponse.success && processedResponse.data) {
          setBookData(processedResponse.data);
        }
      } catch (error) {
        alert('별점 저장 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    }, 500);
  };
  
  const handleMemoSave = async () => {
    if (memoText.trim()) {
      try {
        setLoading(true);
        const { accessToken } = await getAccessToken();
        // 서버에 메모 저장
        await addMyBookMemo(accessToken || '', parseInt(bookId), memoText.trim());
        setMemoModalOpen(false);
        setMemoText("");
        if (onModified) { 
          onModified(); 
        }
        // 저장 후 마지막 페이지 fetch
        //const lastPage = Math.floor((totalMemos + 1) / PAGE_SIZE); // 0-based page
        const firstPage = 0;
        const memosResponse = await getMyBookMemos(accessToken || '', parseInt(bookId), firstPage, PAGE_SIZE);
        const processedMemosResponse = processApiResponse(memosResponse);
        if (processedMemosResponse.success) {
          // 기존 memos에서 마지막 페이지 이전까지는 그대로 두고 마지막 페이지만 교체
          setMemos(prev => {
            //const prevPages = prev.slice(0, lastPage * PAGE_SIZE);
            const prevPages = prev.length > PAGE_SIZE ? prev.slice(PAGE_SIZE, prev.length) : [];
            return [...(processedMemosResponse.data || []), ...prevPages];
          });
          const lastPage = Math.max(0, Math.floor(memos.length / PAGE_SIZE) - 1);
          setCurrentPage(lastPage);
          setHasMore(lastPage < processedMemosResponse.page.last);
          setTotalMemos(processedMemosResponse.page.total);
          // 마지막 메모로 이동
         // const lastMemoIndex = (lastPage * PAGE_SIZE) + ((processedMemosResponse.data || []).length - 1);
          //setCurrentMemoIndex(lastMemoIndex);
          setCurrentMemoIndex(0);
        }
      } catch (error) {
        alert('메모 저장 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleEditClick = (index) => {
    setEditingIndex(index);
    setEditText(memos[index].memo);
    setEditModalOpen(true);
  };

  const handleEditSave = async () => {
    if (editText.trim()) {
      try {
        setLoading(true);
        const { accessToken } = await getAccessToken();
        // 서버에 메모 수정 저장
        const memoId = memos[editingIndex].id;
        await modifyMyBookMemo(accessToken || '', memoId, editText.trim());
        setEditModalOpen(false);
        setEditText("");
        if (onModified) {
          onModified();
        }
        // 수정 후 현재 페이지 fetch
        const indexPage = Math.floor(editingIndex / PAGE_SIZE);
        const memosResponse = await getMyBookMemos(accessToken || '', parseInt(bookId), indexPage, PAGE_SIZE);
        const processedMemosResponse = processApiResponse(memosResponse);
        if (processedMemosResponse.success) {
          setMemos(prev => {
            const prevPages = prev.slice(0, indexPage * PAGE_SIZE);
            return [...prevPages, ...(processedMemosResponse.data || [])];
          });
          const lastPage = Math.max(0, Math.floor(memos.length / PAGE_SIZE) - 1);
          setCurrentPage(lastPage);
          setHasMore(lastPage < processedMemosResponse.page.last);
          setTotalMemos(processedMemosResponse.page.total);
        }
      } catch (error) {
        alert('메모 수정 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDeleteClick = (index) => {
    setDeletingIndex(index);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      const memoId = memos[deletingIndex].id;
      await deleteMyBookMemo(accessToken || '', memoId);
      setDeleteModalOpen(false);
      if (onModified) {
        onModified();
      }
      // 삭제 후 현재 페이지 fetch
      const indexPage = Math.floor(deletingIndex / PAGE_SIZE);
      const memosResponse = await getMyBookMemos(accessToken || '', parseInt(bookId), indexPage, PAGE_SIZE);
      const processedMemosResponse = processApiResponse(memosResponse);
      if (processedMemosResponse.success) {
        setMemos(prev => {
          const prevPages = prev.slice(0, indexPage * PAGE_SIZE);
          return [...prevPages, ...(processedMemosResponse.data || [])];
        });
        const lastPage = Math.max(0, Math.floor(memos.length / PAGE_SIZE) - 1);
        setCurrentPage(lastPage);
        setHasMore(lastPage < processedMemosResponse.page.last);
        setTotalMemos(processedMemosResponse.page.total);
    // 삭제 후 현재 인덱스 조정
        setCurrentMemoIndex(Math.min(currentMemoIndex, (memos || []).length - 1));
    }
    } catch (error) {
      alert('메모 삭제 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handlePrevMemo = () => {
    if (currentMemoIndex > 0) {
      setCurrentMemoIndex(currentMemoIndex - 1);
    }
  };

  const handleNextMemo = () => {
    if (currentMemoIndex < memos.length - 1) {
      setCurrentMemoIndex(currentMemoIndex + 1);
      
      // 페이지 끝에 도달하면 다음 페이지 로드
      if (currentMemoIndex >= memos.length - 3 && hasMore && !loadingMore) {
        loadMoreMemos();
      }
    }
  };

  const handleReadPageSave = async () => {
    const pageNum = parseInt(readPageText);
    if (isNaN(pageNum) || pageNum < 0 || pageNum > 9999) {
      alert('올바른 페이지 수를 입력해주세요. (0-9999)');
      return;
    }

    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      // 서버에 읽은 페이지 저장
      const response = await putMyBookReadPage(accessToken || '', parseInt(bookId), pageNum);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success && processedResponse.data) {
        setBookData(processedResponse.data);
        setReadPageModalOpen(false);
        setReadPageText("");
        if (onModified) {
          onModified();
        }
      } else {
        alert(processedResponse.errorMessage || '읽은 페이지 저장에 실패했습니다.');
      }
    } catch (error) {
      console.error('읽은 페이지 저장 중 오류:', error);
      alert('읽은 페이지 저장 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const popupBookHistory = () => {
    //navigate(`/book-history/${bookId}`);
    setShowBookHistoryModal(true);
  };

  const handleBookHistoryClose = (modified) => {
    setShowBookHistoryModal(false);
  };

  // 로딩 중이거나 에러가 있는 경우 처리
  if (loading) {
    return (
      <>
        <div style={{background:'#eae8e9', minHeight:'100vh'}}>
          <div style={{padding: '20px', textAlign: 'center'}}>로딩 중...</div>
        </div>
        <LoadingOverlay isLoading={loading} />
      </>
    );
  }

  if (error || !bookData) {
    return (
      <ErrorContainer>
        <ErrorMessage>{error || '책 정보를 찾을 수 없습니다.'}</ErrorMessage>
      </ErrorContainer>
    );
  }

  // API 데이터를 기존 sampleBookData 형식으로 변환
  const transformedData = {
    id: bookData.id,
    score: bookData.score,
    title: bookData.title,
    author: bookData.author + ' / ' + bookData.publisher,
    period: stringFrDate(bookData.readFr, 'yyyy-MM-dd', '-') + ' ~ ' + stringFrDate(bookData.readTo, 'yyyy-MM-dd', '-'),
    dday: getDday(bookData.readTo),
    badge: ownership2text(bookData.ownership),
    cover: bookData.cover,
    readPage: bookData.readPage || 0,
    pageNum: bookData.pageNum || 0
  };

  return (
    <>
      <PageWrapper>
        <BookInfoBox>
          <BookInfoContent>
            <Title>{transformedData.title}</Title>
            <Period>{transformedData.period}</Period>
            <TotalTimeBox>
              <TimerIcon><FaRegClock size={18} color="#fff" /></TimerIcon>
              <TotalTimeText>총 독서 시간 {formatTime(totalReadTime)}</TotalTimeText>
            </TotalTimeBox>
            <HistoryText
              onClick={() => /*navigate(`/book-history/${bookId}`)*/popupBookHistory()}
            >
              <FaAngleRight size={10} color="#2346a9" style={{marginRight:4, verticalAlign:'middle'}} />
              독서 이력 {totalReadCnt}회
            </HistoryText>
          </BookInfoContent>
          <SeparatorBar />
          <InfoRow>
            <InfoCard onClick={() => setScoreModalOpen(true)}>
              <LuHeart size={22} color="#898989" style={{marginBottom:4}} />
              <div>내 별점</div>
              <InfoValue>{transformedData.score}</InfoValue>
            </InfoCard>
            <InfoCard onClick={() => {
              setReadPageText(transformedData.readPage.toString());
              setReadPageModalOpen(true);
            }}>
              <FaRegFileAlt size={22} color="#898989" style={{marginBottom:4}} />
              <div>읽은 페이지</div>
              <InfoValue>{transformedData.readPage}p</InfoValue>
            </InfoCard>
            <InfoCard onClick={() => setMemoModalOpen(true)}>
              <RxPencil2 size={22} color="#898989" style={{marginBottom:4}} />
              <div>메모</div>
              <InfoValue>{totalMemos}장</InfoValue>
            </InfoCard>
          </InfoRow>
        </BookInfoBox>
        {scoreModalOpen && (
          <ModalOverlay>
            <ScoreModal>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}>별점 선택</div>
              <ScoreRow>
                {[1,2,3,4,5].map((score) => (
                  <ScoreHeart key={score} selected={transformedData.score >= score} onClick={() => handleScoreClick(score)}>
                    {transformedData.score >= score ? <FaHeart /> : <LuHeart />}
                  </ScoreHeart>
                ))}
              </ScoreRow>
              <ModalCloseBtn onClick={()=>setScoreModalOpen(false)}>닫기</ModalCloseBtn>
            </ScoreModal>
          </ModalOverlay>
        )}
        {memoModalOpen && (
          <MemoModalOverlay>
            <MemoModal>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}>메모 남기기</div>
              <MemoTextarea
                value={memoText}
                onChange={e => setMemoText(e.target.value)}
                placeholder="메모를 입력하세요..."
                autoFocus
              />
              <MemoModalBtnRow>
                <MemoModalBtn onClick={()=>setMemoModalOpen(false)}>취소</MemoModalBtn>
                <MemoModalBtn style={{background:'#244ac2', color:'#fff'}} onClick={handleMemoSave}>저장</MemoModalBtn>
              </MemoModalBtnRow>
            </MemoModal>
          </MemoModalOverlay>
        )}
        {readPageModalOpen && (
          <ReadPageModalOverlay onClick={()=>{
            setReadPageModalOpen(false);
            setReadPageText("");
          }}>
            <ReadPageModal onClick={e => e.stopPropagation()}>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}>읽은 페이지</div>
              <ReadPageInput
                type="number"
                value={readPageText}
                onChange={e => {
                  const value = e.target.value;
                  //if (value.length <= 4 && !isNaN(value) && parseInt(value) >= 0) {
                    setReadPageText(value);
                  //}
                }}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    handleReadPageSave();
                  }
                }}
                placeholder="페이지 수를 입력하세요"
                min="0"
                max="9999"
                autoFocus
              />
              <ReadPageModalBtnRow>
                <ReadPageModalBtn onClick={()=>{
                  setReadPageModalOpen(false);
                  setReadPageText("");
                }}>취소</ReadPageModalBtn>
                <ReadPageModalBtn style={{background:'#244ac2', color:'#fff'}} onClick={handleReadPageSave}>저장</ReadPageModalBtn>
              </ReadPageModalBtnRow>
            </ReadPageModal>
          </ReadPageModalOverlay>
        )}
        <MemoSectionBg>
          <MemoSection>
            <MemoHeader>
              메모
              <AddMemoBtn onClick={()=>setMemoModalOpen(true)}>+ 남기기</AddMemoBtn>
            </MemoHeader>
            {memos.length > 0 ? (
              <>
                <MemoBoxContainer>
            <MemoBox>
                    {memos[Math.min(currentMemoIndex, memos.length - 1)].memo}
              <MemoActions>
                <ActionIcon onClick={() => handleEditClick(currentMemoIndex)}>
                  <FiEdit2 size={16} color="#bbb" />
                </ActionIcon>
                <ActionIcon onClick={() => handleDeleteClick(currentMemoIndex)}>
                  <FiTrash2 size={16} color="#bbb" />
                </ActionIcon>
              </MemoActions>
            </MemoBox>
                  <ArrowButton 
                    direction="left" 
                    onClick={handlePrevMemo}
                    disabled={currentMemoIndex === 0}
                  >
                    <IoChevronBack size={20} color="#666" />
                  </ArrowButton>
                  <ArrowButton 
                    direction="right" 
                    onClick={handleNextMemo}
                    disabled={currentMemoIndex === totalMemos - 1}
                  >
                    <IoChevronForward size={20} color="#666" />
                  </ArrowButton>
                </MemoBoxContainer>
            <Pagination>
              <PaginationText>{currentMemoIndex + 1} / {totalMemos}</PaginationText>
            </Pagination>
              </>
            ) : (
              <div style={{textAlign: 'center', color: '#888', padding: '40px 0'}}>
                아직 메모가 없습니다.
              </div>
            )}
          </MemoSection>
        </MemoSectionBg>
        {editModalOpen && (
          <MemoModalOverlay>
            <MemoModal>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}>메모 수정</div>
              <MemoTextarea
                value={editText}
                onChange={e => setEditText(e.target.value)}
                placeholder="메모를 입력하세요..."
                autoFocus
              />
              <MemoModalBtnRow>
                <MemoModalBtn onClick={()=>setEditModalOpen(false)}>취소</MemoModalBtn>
                <MemoModalBtn style={{background:'#244ac2', color:'#fff'}} onClick={handleEditSave}>저장</MemoModalBtn>
              </MemoModalBtnRow>
            </MemoModal>
          </MemoModalOverlay>
        )}
        {deleteModalOpen && (
          <MemoModalOverlay>
            <MemoModal>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}>메모 삭제</div>
              <div style={{color:'#555', fontSize:15, marginBottom:20, textAlign:'center'}}>
                메모를 삭제하시겠습니까?
              </div>
              <MemoModalBtnRow>
                <MemoModalBtn onClick={()=>setDeleteModalOpen(false)}>취소</MemoModalBtn>
                <MemoModalBtn style={{background:'#e74c3c', color:'#fff'}} onClick={handleDeleteConfirm}>삭제</MemoModalBtn>
              </MemoModalBtnRow>
            </MemoModal>
          </MemoModalOverlay>
        )}
      </PageWrapper>
      {showBookHistoryModal && (
        <BookHistoryModal bookId={bookId} onClose={handleBookHistoryClose} />
      )}
      {loadingMore && <LoadingOverlay isLoading={loadingMore} />}
    </>
  );
} 